
import { defineComponent, onMounted, ref, computed } from "vue";
import { StepperComponent } from "@/assets/ts/components/_StepperComponent";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { useForm } from "vee-validate";
import { Field, ErrorMessage } from "vee-validate";
import * as Yup from "yup";
import { getcountries, getcities, getTimeZones } from "@/api/common";
import { activateConfirm, activateSave } from "@/api/ai";

import { confirm_register, save_register, validateMultiple, saveRegMultiple } from "@/api/register";
  

interface  Step1 {
  businessName: string; 
}

interface Step2 {
  prospectFirstName: string;
  prospectLastName: string;
  prospectEmail: string;
}

interface Step3 {
    prospectContactPhone: string;
    companyAddress: string;
    country: string;
    country_text: string;
    city_text: string;
    countryState: string;
    city: string;
    postalCode: string;
    timezone: string;
}

interface Step4 {
    username: string;
    password: string;
    cpassword: string;
    firstname: string;
    lastname: string;
    mi: string;
    bd : string;
    sponsorid: string;
    uplineid: string;
    position: string; 
    userid: string;
    securitypin: string;
    encodingType: string;
    aiActivation: string;
    shoudDisplayRegistrationConfirmation: boolean;

    //to  cater regmultiple
    spid: string;
    upid: string;
    usid: string;
    secpin: string; 
    activationRecid: number;

}

interface KTCreateApp extends Step1, Step2, Step3, Step4 {}

export default defineComponent({
  name: "create-app-modal",
  components: {
    Field,
    ErrorMessage
  },
  props: {
    activation: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  setup(props) {
    const _stepperObj = ref<StepperComponent | null>(null);
    const createAppRef = ref<HTMLElement | null>(null);
    const currentStepIndex = ref(0);

    const formData = ref<KTCreateApp>({
            businessName: "", 
            prospectFirstName: "",
            prospectLastName: "",
            prospectEmail: "",
            prospectContactPhone: "",
            companyAddress: "",
            country: "",
            country_text: "",
            countryState: "",
            city: "",
            city_text: "",
            postalCode: "",
            timezone: "",
            username: "",
            password: "",
            cpassword: "",
            firstname: "",
            lastname: "",
            mi: "",
            bd : "",
            sponsorid: "",
            uplineid: "",
            position: "",  
            userid: "",
            securitypin: "",
            encodingType: "activation",
            aiActivation: "",
            shoudDisplayRegistrationConfirmation: false,
            spid: "",
            upid: "",
            usid: "",   
            secpin: "",
            activationRecid: 0
    });

    onMounted(() => {
      _stepperObj.value = StepperComponent.createInsance(
        createAppRef.value as HTMLElement
      );
      httpGetCountries();
      httpGetTimeZones();
    });

    const createAppSchema = [
      Yup.object({
        businessName: Yup.string()
          .required()
          .label("Account Name"), 
      }),
      Yup.object({
        prospectFirstName: Yup.string()
          .required()
          .label("First Name")
      }),
      Yup.object({
        prospectLastName: Yup.string()
          .required()
          .label("Last Name")
      }), 
      Yup.object({
        country: Yup.string()
          .required()
          .label("Country")
      }),
    ];

    // extracts the individual step schema
    const currentSchema = computed(() => {
      return createAppSchema[currentStepIndex.value];
    });

    const totalSteps = computed(() => {
      if (!_stepperObj.value) {
        return;
      }

      return _stepperObj.value.totatStepsNumber;
    });

    const { resetForm, handleSubmit } = useForm<Step1 | Step2 | Step3 | Step4>({
      validationSchema: currentSchema
    });

    const previousStep = () => {
      if (!_stepperObj.value) {
        return;
      }

      currentStepIndex.value--;

      _stepperObj.value.goPrev();
    };

    const handleStep = handleSubmit(values => {
      formData.value = {
        ...formData.value,
        ...values
      };

      currentStepIndex.value++;

      if (!_stepperObj.value) {
        return;
      }

      _stepperObj.value.goNext();
    });

    const isSubmitting = ref(false);

    const formSubmit = async () => {


      formData.value.country_text = selectedCountry.value ? selectedCountry.value.iso_code_2 : '';
      formData.value.city_text = selectedCity.value ? selectedCity.value.name : '';
      formData.value.shoudDisplayRegistrationConfirmation = false;

      formData.value.spid = formData.value.sponsorid;
      formData.value.upid = formData.value.uplineid;
      formData.value.usid = formData.value.userid;
      formData.value.secpin = formData.value.securitypin;
      formData.value.activationRecid = props.activation?.recid || 0;

        isSubmitting.value = true;
        if(formData.value.encodingType === 'regnew'){ 
           const response: any =   await confirm_register(formData.value);
           isSubmitting.value = false;
          if(response.data !== undefined && response.data.result !== "SUCCESS") {  
            Swal.fire({
            title: "",
            text: response.data.message,
            icon: "error",
            confirmButtonClass: "btn btn-secondary"
            });  
            if (!_stepperObj.value) {
              isSubmitting.value = false;
              return;
            }
            currentStepIndex.value = 0;
            _stepperObj.value.goFirst();
            isSubmitting.value = false;
            return;
          } 
          formData.value.shoudDisplayRegistrationConfirmation = true;

                 Swal.fire({
                    title: "Confirm Submission",
                    html: `
                      <div class="fw-bold">
                        <h4 class="text-gray-800 fw-bolder">Network Setup confirmation</h4>
                        <div class="fs-6 text-gray-600">
                          ${formData.value.firstname}, you are requesting to register a new account with
                          <a class="fw-bolder" href="javascript:;">${response.data?.sponsorname} (${formData.value.sponsorid})</a> as your Sponsor and you
                          will be placed on the <a class="fw-bolder" href="javascript:;">${formData.value.position === 'L' ? 'Left' : 'Right'}</a> below your upline
                          <a class="fw-bolder" href="javascript:;">${response.data?.uplinename} (${response.data?.actualuplineid})</a>
                          ${formData.value.uplineid !== response.data?.actualuplineid ?
                            `<div class='pt-5'>Your original requested upline is <a class='fw-bolder' href='javascript:;'>${response.data?.requesteduplinename} (${formData.value.uplineid})</a></div>` : ''} 
                        </div>
                      </div>
                    `,
                    icon: "question",
                    showCancelButton: true,
                    confirmButtonText: "Yes, submit",
                    cancelButtonText: "Cancel",
                    customClass: {
                      confirmButton: "btn fw-bold btn-light-primary",
                      cancelButton: "btn fw-bold btn-light"
                    }
                  }).then(async result => {
                    if (result.isConfirmed) {
                      // Place your submission logic here
                      // For example: window.location.reload();
                        isSubmitting.value = true;
                        const response2: any =   await save_register(formData.value);  
                        isSubmitting.value = false;
                        if(response2.data !== undefined && response2.data.result === "FAILED") {  
                            Swal.fire({
                                title: "",
                                text: response2.data.message,
                                icon: "error",
                                confirmButtonClass: "btn btn-secondary"
                            });  
                            if (!_stepperObj.value) {
                                return;
                            }
                            currentStepIndex.value = 0;
                            _stepperObj.value.goFirst();
                            return;
                        }  
                        
                        if(response2.data !== undefined && response2.data.result === "SUCCESS") {
                                Swal.fire({
                                    text: response2.data.message,
                                    icon: "success",
                                    buttonsStyling: false,
                                    confirmButtonText: "Ok",
                                    customClass: {
                                    confirmButton: "btn fw-bold btn-light-primary"
                                    }
                                }).then(() => {
                                    window.location.reload();
                                });
                        }

                    }
                  });
                return;        
            }
            



        isSubmitting.value = true;
        if(formData.value.encodingType === 'regmultiple'){ 
           const response: any =   await validateMultiple(formData.value);
           isSubmitting.value = false;
          if(response.data !== undefined && response.data.result !== "SUCCESS") {  
            Swal.fire({
            title: "",
            text: response.data.message,
            icon: "error",
            confirmButtonClass: "btn btn-secondary"
            });  
            if (!_stepperObj.value) {
              isSubmitting.value = false;
              return;
            }
            currentStepIndex.value = 0;
            _stepperObj.value.goFirst();
            isSubmitting.value = false;
            return;
          } 
          formData.value.shoudDisplayRegistrationConfirmation = true;

                 Swal.fire({
                    title: "Confirm Submission",
                    html: `
                        <div class="d-flex flex-stack flex-grow-1">
                        <div class="fw-bold">
                            <h4 class="text-gray-800 fw-bolder">Network Setup confirmation</h4>
                            <div class="fs-6 text-gray-600">
                            ${response?.data?.fullname}, you are requesting to register a new account with
                            <a class="fw-bolder" href="javascript:;">${response?.data?.sponsorname} (${formData.value.spid})</a> as your Sponsor and you
                            will be placed on the <a class="fw-bolder" href="javascript:;">${formData.value.position === 'L' ? 'Left' : 'Right'}</a> below your upline
                            <a class="fw-bolder" href="javascript:;">${response?.data?.uplinename} (${response?.data?.actualuplineid})</a>
                            ${formData.value.upid !== response?.data?.actualuplineid ?
                                `<div class='pt-5'>Your original requested upline is <a class='fw-bolder' href='javascript:;'>${response?.data?.requesteduplinename} (${formData.value.upid})</a></div>` : ''}
                            <div class="pt-5">
                                Please click Submit to Proceed
                            </div>
                            </div>
                        </div>
                        </div>
                    `,
                    icon: "question",
                    showCancelButton: true,
                    confirmButtonText: "Yes, submit",
                    cancelButtonText: "Cancel",
                    customClass: {
                        confirmButton: "btn fw-bold btn-light-primary",
                        cancelButton: "btn fw-bold btn-light"
                    }
                    }).then(async result => {
                    if (result.isConfirmed) {
                      // Place your submission logic here
                      // For example: window.location.reload();
                        isSubmitting.value = true;
                        const response2: any =   await saveRegMultiple(formData.value);  
                        isSubmitting.value = false;
                        if(response2.data !== undefined && response2.data.result === "FAILED") {  
                            Swal.fire({
                                title: "",
                                text: response2.data.message,
                                icon: "error",
                                confirmButtonClass: "btn btn-secondary"
                            });  
                            if (!_stepperObj.value) {
                                return;
                            }
                            currentStepIndex.value = 0;
                            _stepperObj.value.goFirst();
                            return;
                        }  
                        
                        if(response2.data !== undefined && response2.data.result === "SUCCESS") {
                                Swal.fire({
                                    text: response2.data.message,
                                    icon: "success",
                                    buttonsStyling: false,
                                    confirmButtonText: "Ok",
                                    customClass: {
                                    confirmButton: "btn fw-bold btn-light-primary"
                                    }
                                }).then(() => {
                                    window.location.reload();
                                });
                        }

                    }
                  });
                return;        
            }



        isSubmitting.value = true;
        if(formData.value.encodingType === 'activation'){ 
           const response: any =   await activateConfirm(formData.value);
           isSubmitting.value = false;
          if(response.data !== undefined && response.data.result !== "SUCCESS") {  
            Swal.fire({
            title: "",
            text: response.data.message,
            icon: "error",
            confirmButtonClass: "btn btn-secondary"
            });  
            if (!_stepperObj.value) {
              isSubmitting.value = false;
              return;
            }
            currentStepIndex.value = 0;
            _stepperObj.value.goFirst();
            isSubmitting.value = false;
            return;
          } 
          formData.value.shoudDisplayRegistrationConfirmation = true;

                 Swal.fire({
                    title: "Confirm Submission",
                    text: `You are requesting to activate Business AI for the ${formData.value.businessName}. Please click Submit to Proceed`,
                    icon: "question",
                    showCancelButton: true,
                    confirmButtonText: "Yes, submit",
                    cancelButtonText: "Cancel",
                    customClass: {
                        confirmButton: "btn fw-bold btn-light-primary",
                        cancelButton: "btn fw-bold btn-light"
                    }
                    }).then(async result => {
                    if (result.isConfirmed) {
                      // Place your submission logic here
                      // For example: window.location.reload();
                        isSubmitting.value = true;
                        const response2: any =   await activateSave(formData.value);  
                        isSubmitting.value = false;
                        if(response2.data !== undefined && response2.data.result === "FAILED") {  
                            Swal.fire({
                                title: "",
                                text: response2.data.message,
                                icon: "error",
                                confirmButtonClass: "btn btn-secondary"
                            });  
                            if (!_stepperObj.value) {
                                return;
                            }
                            currentStepIndex.value = 0;
                            _stepperObj.value.goFirst();
                            return;
                        }  
                        
                        if(response2.data !== undefined && response2.data.result === "SUCCESS") {
                                Swal.fire({
                                    text: response2.data.message,
                                    icon: "success",
                                    buttonsStyling: false,
                                    confirmButtonText: "Ok",
                                    customClass: {
                                    confirmButton: "btn fw-bold btn-light-primary"
                                    }
                                }).then(() => {
                                    window.location.reload();
                                });
                        }

                    }
                  });
                return;        
            }
          
    };

    resetForm({
      values: {
        ...formData.value
      }
    });



    
    const countries = ref([]) as any; 
    const cities = ref([]) as any;   
    const timeZones = ref([]) as any;   
    const countriesLoading = ref(true);
    const citiesLoading = ref(true);

    const httpGetCountries = async () => {
      countriesLoading.value = true;
      countries.value = [];
      const response = await getcountries();
      if (response.data?.countries) {
        countries.value = response.data.countries;
      }
      countriesLoading.value = false;
    };

    const httpGetTimeZones =  async () => { 
      timeZones.value = [];
        const response = await getTimeZones(); 
        if(response.data !== undefined && response.data.timezones !== undefined) { 
          timeZones.value = response.data.timezones; 
        }
    }; 

    const getCities = async (country_id) => {
      citiesLoading.value = true;
      cities.value = [];
      const response = await getcities(country_id);
      if (response.data?.cities) {
        cities.value = response.data.cities;
      }
      citiesLoading.value = false;
    };

    const selectedCountry = computed(() => {
      const countryId = parseInt(formData.value.country, 10);
      return countries.value.find(c => parseInt(c.country_id, 10) === countryId) || null;
    });
    const selectedCity = computed(() => {
      const cityId = parseInt(formData.value.city, 10);
      return cities.value.find(city => parseInt(city.zone_id, 10) === cityId) || null;
    });
 

    return {
        countriesLoading,
        citiesLoading,
        countries, 
        selectedCountry,
        selectedCity,
        getCities,
        cities,
        timeZones,
        handleStep,
        formSubmit,
        previousStep,
        createAppRef,
        currentStepIndex,
        totalSteps,
        formData,
        isSubmitting
    };
  }
});
